import create from "zustand";
import { persist } from "zustand/middleware";
import { CalendarView } from "../components/nav/NavigateToReport";
import { ProductModel } from "../components/PurchasePage";
import { ExportType } from "../enums/ExportType";
import { Errors } from "../hooks/useAISuggestions";
import { UserModelType } from "./useAuthStore";
import useTutorial from "./useTutorial";

//data class UpdateTemplateModel(val templateName : String)
export type UpdateTemplateModel = {
  templateName: string;
};

//data class DownloadEntriesModel(val onlineEntryIds : List<Int>,val folderId: Int = -1)
export type DownloadEntriesModel = {
  onlineEntryIds: number[];
  folderId: number;
};

export type FolderModel = {
  // data class FolderModel(val id : Int,  val name : String, val description : String, val userId : String, val visible: Boolean)
  id: number;
  name: string;
  description: string;
  userId: string;
  visible: boolean;
  isDefaultFolder: boolean;
};

export type CreateFolderResult = {
  errorList: Errors["errorList"];
  folder?: FolderModel;
};

export type NewEntriesModel = {
  entries: NewEntryModel[];
};

export type DeleteFolderResult = {
  errorList: Errors["errorList"];
  folder?: FolderModel;
};

export type NewEntriesResult = {
  errorList: Errors["errorList"];
};

export type LoginResult = {
  errorList: Errors;
  tokenPair: {
    accessToken: string;
    refreshToken: string;
  };
  user: UserModelType;
};

export type UpdateFolderRequest = {
  id: number;
  name: string;
};

export type UpdateFolderResult = {
  errorList: Errors["errorList"];
  folder: FolderModel | null;
};
//data class EntryModel(val id : Int, val name : String, val description : String, val reportSectionId : Int, val folderId : Int,val maxHours : Double, val visible : Boolean, val userId : String, val type : String)
export type CreateEntryResult = {
  errorList: Error[];
  entry: EntryModel | null;
};
// data class NewEntryModel( val name : String, val description : String, val reportSectionName : String, val folderId : Int,val maxHours : Double, val visible : Boolean, val userId : String, val type : String,val sortOrder : Int, val dates : Array<Long>)
export type NewEntryModel = {
  name: string;
  description: string;
  reportSectionName: string;
  folderId: number;
  maxHours: number;
  visible: boolean;
  userId: string;
  type: string;
  sortOrder: number;
  dates: Array<number>;
};
export type NewICalEntryModel = {
  index: number;
  name: string;
  description: string;
  reportSectionName: string;
  folderId: number;
  maxHours: number;
  visible: boolean;
  userId: string;
  type: string;
  sortOrder: number;
  startDate: Date | null;
  endDate: Date | null;
  dates: Array<number>;
};
//data class SetEntryAsCompletedModel(val id : Int, val reportSectionId: Int, val sortOrder: Int, val dates : Array<Long>, val isRandomEntry : Boolean)

export type SetEntryAsCompletedModel = {
  id: number;
  reportSectionName: string;
  sortOrder: number;
  dates: Array<number>;
  datesToDelete: Array<number>;
  isRandomEntry: boolean;
};

// data class SetEntriesAsCompletedModel(val completedEntries : Array<SetEntryAsCompletedModel>)

export type SetEntriesAsCompletedModel = {
  completedEntries: Array<SetEntryAsCompletedModel>;
};

export type EntryModel = {
  id: number;
  name: string;
  description: string;
  reportSectionName: string;
  folderId: number;
  maxHours: number;
  visible: boolean;
  userId: string;
  type: string;
};
export type OnlineEntryModel = {
  id: number;
  name: string;
  description: string;
  reportSection: ReportSection;
  folderId: number;
  maxHours: number;
  visible: boolean;
  userId: string;
  type: string;
};

// data class CompletedEntryModel(val entryId : Int, val originalEntryId : Int, val entryDescription : String,val duration : Double, val formattedDuration : String = "00:00:00")editor
export type CompletedEntryModel = {
  entryId: number;
  originalEntryId: number;
  name: string;
  entryDescription: string;
  type: string;
  reportSectionName: string;
  folderId: number;
  duration: number;
  completionDate: number;
  formattedDuration: string;
};

// @Serializable
// data class UpdateEntryModel(val id : Int, val name : String, val description : String, val reportSectionId : Int, val folderId : Int,val maxHours : Double, val visible : Boolean, val userId : String, val type : String,val sortOrder : Int)
export type UpdateEntryModel = {
  id: number;
  name: string;
  description: string;
  reportSectionName: string;
  folderId: number;
  maxHours: number;
  visible: boolean;
  userId: string;
  type: string;
};

/**
 * @Serializable
data class PartialUpdateCompletedEntryModel(
    val entryId: Int,
    val originalEntryId: Int,
    val description: String,
    val reportSectionName: String,
    val folderId: Int,
    val maxHours: Double,
    val type: String,
)
 */
export type PartialUpdateCompletedEntryModel = {
  entryId: number;
  originalEntryId: number;
  description: string;
  reportSectionName: string;
  folderId: number;
  maxHours: number;
  type: string;
  dateOfCompletion: number;
};

export type ReportSection = {
  id: number;
  name: string;
  type: number;
};

export type UserTemplateModel = {
  id: number;
  name: string;
  userId: string;
};

export type ExportOptions = {
  exportType: ExportType;
};

export type Service = "API" | "STRIPE" | "AI";

/**
 * 
@Serializable
data class ServiceHealth(val service: Service, val httpStatusCode: Int, val message: String) {
    override fun hashCode(): Int {
        return service.hashCode()
    }

    override fun toString(): String {
        return "ServiceHealth(service=$service, httpStatusCode=$httpStatusCode, message='$message')"
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is ServiceHealth) return false

        if (service != other.service) return false

        return true
    }
}

val serviceHealth: HashSet<ServiceHealth> = HashSet()

@Serializable
data class ServicesHealth(val services: List<ServiceHealth>)
 */

type ServiceHealth = {
  service: Service;
  httpStatusCode: number;
  message: string;
  timestamp: number;
};

export type ServicesHealth = {
  services: ServiceHealth[];
};

export type TemplateOption = {
  reportTypeId: number;
  name: string;
  reportSections: ReportSection[];
};
export type GetTemplatesResult = {
  templates: TemplateOption[];
};

export type ReportType = {
  id: number;
  name: string;
};
export type GetProductsResponse = {
  errorList: Errors["errorList"];
  products: ProductModel[];
};
export type GetPackagesResponse = {
  packages: ProductModel[];
  errorList: Errors["errorList"];
};
export type GetReportSectionsResult = {
  errorList: Errors["errorList"];
  reportSections: ReportSection[];
};

type BerichtsheftContext = {
  selectedYear: number | null;
  setSelectedYear: (year: number | null) => void;
  selectedFolderId: number;
  setSelectedFolderId: (folder: number) => void;
  folderToEdit: number | null;
  setFolderToEdit: (folder: number | null) => void;
  folders: FolderModel[];
  setFolders: (folders: FolderModel[]) => void;
  entry: number | null;
  setEntry: (entry: number | null) => void;
  focusedCompletedEntry: CompletedEntryModel | null;
  setFocusedCompletedEntry: (
    completedEntry: CompletedEntryModel | null
  ) => void;
  // entries: EntryModel[];
  // setEntries: (entries: EntryModel[]) => void;
  selectedEntries: EntryModel[];
  setSelectedEntries: (entries: EntryModel[]) => void;

  // selectedReportSection: string | null,
  // setSelectedReportSection: (reportSection: string | null) => void,
  selectedDates: number[];
  setSelectedDates: (dates: number[]) => void;
  selectedReportSection: string | null;
  setSelectedReportSection: (reportSection: string) => void;
  exportOptions: ExportOptions;
  setExportOptions: (exportOptions: ExportOptions) => void;
  isExportingPdf: boolean;
  setIsExportingPdf: (isExportingPdf: boolean) => void;
  isExportingDocX: boolean;
  setIsExportingDocX: (isExportingDocX: boolean) => void;
  exportProgress: number;
  setExportProgress: (exportProgress: number) => void;
  exportProgressMax: number;
  setExportProgressMax: (exportProgressMax: number) => void;
  isShowingAISuggestions: boolean;
  setIsShowingAISuggestions: (isShowingAISuggestions: boolean) => void;
  richTextEditorStates: Map<string, string>;
  setRichTextEditorStates: (richTextEditorStates: Map<string, string>) => void;
  openReports: number[];
  setOpenReports: (openReports: number[]) => void;
  openMonths: number[];
  setOpenMonths: (openMonths: number[]) => void;
  reportNavigatorDate: Date;
  setReportNavigatorDate: (date: Date) => void;
  isReportNavigatorOpen: boolean;
  setIsReportNavigatorOpen: (isReportNavigatorOpen: boolean) => void;
  calendarView: CalendarView;
  setCalendarView: (calendarView: CalendarView) => void;
  serviceHealth: ServicesHealth;
  setServiceHealth: (serviceHealth: ServicesHealth) => void;
  isServiceRunning: (service: Service) => boolean;
  isSidebarExpanded: boolean;
  setIsSidebarExpanded: (isSidebarExpanded: boolean) => void;
};

export const useBerichtsheft = create<BerichtsheftContext>()(
  persist(
    (set, get) => ({
      selectedYear: null,
      setSelectedYear: (year: number | null) => {
        localStorage.setItem(
          "selectedYear",
          year !== null ? year.toString() : ""
        );
        return set((state) => ({ ...state, selectedYear: year }));
      },

      selectedFolderId: -1,
      setSelectedFolderId: (folder: number) =>
        set((state) => ({ ...state, selectedFolderId: folder })),
      folderToEdit: null,
      setFolderToEdit: (folder: number | null) =>
        set((state) => ({ ...state, folderToEdit: folder })),
      folders: [],
      setFolders: (folders: FolderModel[]) =>
        set((state) => ({ ...state, folders: folders })),
      entry: null,
      setEntry: (entry: number | null) =>
        set((state) => ({ ...state, entry: entry })),
      focusedCompletedEntry: null,
      setFocusedCompletedEntry: (completedEntry: CompletedEntryModel | null) =>
        set((state) => ({ ...state, focusedCompletedEntry: completedEntry })),
      // entries: [],
      // setEntries: (entries: EntryModel[]) =>
      //   set((state) => ({ ...state, entries: entries })),
      selectedEntries: [],
      setSelectedEntries: (entries: EntryModel[]) =>
        set((state) => ({ ...state, selectedEntries: entries })),
      // selectedReportSection: null,
      // setSelectedReportSection: (reportSection: string | null) => set(state => ({ ...state, selectedReportSection: reportSection })),
      selectedDates: [],
      setSelectedDates: (dates: number[]) =>
        set((state) => ({ ...state, selectedDates: dates })),
      selectedReportSection: null,
      setSelectedReportSection: (reportSection: string) =>
        set((state) => ({ ...state, selectedReportSection: reportSection })),
      exportOptions: {
        exportType: ExportType.DOCX,
      },
      setExportOptions: (exportOptions: ExportOptions) =>
        set((state) => ({ ...state, exportOptions: exportOptions })),
      isExportingPdf: false,
      setIsExportingPdf: (isExportingPdf: boolean) =>
        set((state) => ({ ...state, isExportingPdf: isExportingPdf })),
      isExportingDocX: false,
      setIsExportingDocX: (isExportingDocX: boolean) =>
        set((state) => ({ ...state, isExportingDocX: isExportingDocX })),
      exportProgress: 0,
      setExportProgress: (exportProgress: number) =>
        set((state) => ({ ...state, exportProgress: exportProgress })),
      exportProgressMax: 0,
      setExportProgressMax: (exportProgressMax: number) =>
        set((state) => ({ ...state, exportProgressMax: exportProgressMax })),
      isShowingAISuggestions: false,
      setIsShowingAISuggestions: (isShowingAISuggestions: boolean) =>
        set((state) => ({
          ...state,
          isShowingAISuggestions: isShowingAISuggestions,
        })),
      richTextEditorStates: new Map<string, string>(),
      setRichTextEditorStates: (richTextEditorStates: Map<string, string>) =>
        set((state) => ({
          ...state,
          richTextEditorStates: richTextEditorStates,
        })),
      openReports: [],
      setOpenReports: (openReports: number[]) =>
        set((state) => ({ ...state, openReports: openReports })),
      openMonths: [],
      setOpenMonths: (openMonths: number[]) =>
        set((state) => ({ ...state, openMonths: openMonths })),
      reportNavigatorDate: new Date(),
      setReportNavigatorDate: (date: Date) =>
        set((state) => ({ ...state, reportNavigatorDate: date })),
      isReportNavigatorOpen: false,
      setIsReportNavigatorOpen: (isReportNavigatorOpen: boolean) =>
        set((state) => ({
          ...state,
          isReportNavigatorOpen: isReportNavigatorOpen,
        })),
      calendarView: "SINGLE",
      setCalendarView: (calendarView: CalendarView) =>
        set((state) => ({ ...state, calendarView: calendarView })),
      serviceHealth: {
        services: [
          {
            service: "API",
            httpStatusCode: 200,
            message: "API is running",
            timestamp: Date.now(),
          },
          {
            service: "STRIPE",
            httpStatusCode: 200,
            message: "Stripe is running",
            timestamp: Date.now(),
          },
          {
            service: "AI",
            httpStatusCode: 200,
            message: "AI is running",
            timestamp: Date.now(),
          },
        ],
      },
      setServiceHealth: (serviceHealth: ServicesHealth) =>
        set((state) => ({ ...state, serviceHealth: serviceHealth })),
      isServiceRunning: (service: Service) => {
        return get().serviceHealth.services.some(
          (serviceHealth) =>
            serviceHealth.service === service &&
            serviceHealth.httpStatusCode === 200
        );
      },
      isSidebarExpanded: false,
      setIsSidebarExpanded: (isSidebarExpanded: boolean) =>
        set((state) => ({ ...state, isSidebarExpanded: isSidebarExpanded })),
    }),
    {
      name: "berichtsheft",
      getStorage: () => localStorage,
    }
  )
);

export const useTutorialContext = useTutorial;
